// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalError_header__3Y9e1","footer":"ModalError_footer__2JmD8"};